// @flow

import type {GbiprojectState} from '../types'

export const initialState: GbiprojectState = {
  isLoading: false,
  error: null
}
